"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUrlWithoutBasePath = exports.getAppRoot = void 0;
var DEFAULT_URL = '/';

var getAppRoot = function getAppRoot() {
  var baseElement = document.getElementsByTagName('base')[0];

  if (baseElement) {
    return baseElement.getAttribute('href') || DEFAULT_URL;
  }

  return DEFAULT_URL;
};

exports.getAppRoot = getAppRoot;

var getUrlWithoutBasePath = function getUrlWithoutBasePath(url) {
  var basePath = getAppRoot();
  return url.replace(new RegExp("^".concat(basePath)), '');
};

exports.getUrlWithoutBasePath = getUrlWithoutBasePath;
//# sourceMappingURL=browser.js.map